import React from 'react';
import { RadioGroup, Radio } from '@guardian/src-radio';
import { FieldLabel } from './FieldLabel';
export const RadioSelect = ({ formField, formData, setFormData, }) => (React.createElement(React.Fragment, null,
    React.createElement(FieldLabel, { formField: formField }),
    React.createElement(RadioGroup, { name: formField.name, orientation: "horizontal" }, formField.options.map((option, index) => {
        const isRadioChecked = formField.id in formData &&
            formData[formField.id] === option.value;
        return (React.createElement(Radio, { "data-testid": `form-field-${option.value}`, key: index, label: option.label, value: option.value, name: `${formField.id}`, checked: !!isRadioChecked, onClick: () => setFormData({
                ...formData,
                [formField.id]: option.value,
            }) }));
    }))));
